import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createClient, UsermavenProvider } from '@usermaven/react';

function createUsermavenClient() {
  return createClient({
    tracking_host: 'https://um.dashboardfox.com',
    key: 'UMarTMfvlV',
    autocapture: true,
    formTracking: 'all',
    randomizeUrl: true,
  });
}

let usermavenClient: ReturnType<typeof createUsermavenClient> | null = null;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function renderApp() {
  root.render(
    <React.StrictMode>
      {usermavenClient ? (
        <UsermavenProvider client={usermavenClient}>
          <App />
        </UsermavenProvider>
      ) : (
        <App />
      )}
    </React.StrictMode>
  );
}

// onConsent fires immediately if already accepted, or when user accepts.
// Never fires on deny — analytics never loads without consent.
if ((window as any).concord?.consent?.onConsent) {
  (window as any).concord.consent.onConsent('analytics', () => {
    if (!usermavenClient) {
      usermavenClient = createUsermavenClient();
      (window as any).__dfxAnalyticsReady = true;
      renderApp();
    }
  });
}

renderApp();
reportWebVitals();
